const figmaStyles = require('./figma-styles.json');
const globalStyles = require('./global-styles.json');

const styles = {
    ...globalStyles,
    ...figmaStyles,
    colors: {
        ...globalStyles.colors,
        ...figmaStyles.colors,
    },
    breakpoints: {
        ...globalStyles.breakpoints,
        ...figmaStyles.breakpoints,
    },
    'iconography-sizes': {
        ...globalStyles['iconography-sizes'],
        ...figmaStyles['iconography-sizes'],
    },
};

export default styles;
